import { render, staticRenderFns } from "./ActivitesList.vue?vue&type=template&id=3131e8bf"
import script from "./ActivitesList.vue?vue&type=script&lang=js"
export * from "./ActivitesList.vue?vue&type=script&lang=js"
import style0 from "./ActivitesList.vue?vue&type=style&index=0&id=3131e8bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports